var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Poison50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M2.852 22.197H46.852V26.197H2.852z",
    transform: "rotate(-45.001 24.851 24.197)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M39 4.1A3 3 0 1 0 39 10.1A3 3 0 1 0 39 4.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M42 7.1A3 3 0 1 0 42 13.1 3 3 0 1 0 42 7.1zM8 35.1A3 3 0 1 0 8 41.1 3 3 0 1 0 8 35.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M10 38.1A3 3 0 1 0 10 44.1A3 3 0 1 0 10 38.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M21.101 2.22H25.101V46.22H21.101z",
    transform: "rotate(-45.001 23.101 24.22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M28 43.1h-8c-2.2 0-4-1.8-4-4v-6h16v6C32 41.3 30.2 43.1 28 43.1zM9 4.1A3 3 0 1 0 9 10.1 3 3 0 1 0 9 4.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M6 7.1A3 3 0 1 0 6 13.1 3 3 0 1 0 6 7.1zM40 35.1A3 3 0 1 0 40 41.1 3 3 0 1 0 40 35.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#469C10",
    d: "M38 38.1A3 3 0 1 0 38 44.1A3 3 0 1 0 38 38.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#64DD17",
    d: "M24 5.100000000000001A15 14 0 1 0 24 33.1A15 14 0 1 0 24 5.100000000000001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64DD17",
    d: "M34,33.1H14c-1.7,0-3-1.3-3-3v-8h26v8C37,31.7,35.7,33.1,34,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64DD17",
    d: "M28 38.1h-8c-1.1 0-2-.9-2-2v-6h12v6C30 37.2 29.1 38.1 28 38.1zM20 39.1H22V41.1H20zM26 39.1H28V41.1H26zM23 39.1H25V41.1H23z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#33691E",
    d: "M24 29.1c-1 .2-2.5 2.7-2.5 4 0 .6.6 1 1 1 .8 0 1.3-.8 1.5-1.3.2.6.6 1.3 1.5 1.3.6 0 1-.4 1-1C26.5 31.8 25 29.3 24 29.1zM30 22.1A4 4 0 1 0 30 30.1 4 4 0 1 0 30 22.1zM18 22.1A4 4 0 1 0 18 30.1 4 4 0 1 0 18 22.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCFF90",
    d: "M20 36.1H22V38.1H20zM26 36.1H28V38.1H26zM23 36.1H25V38.1H23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Poison50);
export default __webpack_public_path__ + "static/media/icons8-poison-50.cf2ba6e0da34dfa1dacdeb0a1b96d385.svg";
export { ForwardRef as ReactComponent };